import React, { useState } from "react";
import { createUserWithEmailAndPassword } from "firebase/auth";
import { Link } from "react-router-dom";
import { auth } from "./firebase";

import "./assest_design/Register.css";
import logo from "./assets/procode_za_logo.jpg";

function Register() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    if (password !== confirm) {
      setError("Passwords do not match.");
      return;
    }

    try {
      await createUserWithEmailAndPassword(auth, email, password);
      setSuccess("Your account has been created successfully.");
      setEmail("");
      setPassword("");
      setConfirm("");
    } catch (err) {
      setError("Error creating account. Please try again.");
    }
  };

  return (
    <div className="register-container">

      {/* LEFT IMAGE PANEL */}
      <div className="register-left">
        <img
          src="https://images.unsplash.com/photo-1502646434673-f914c2b11728?q=80&w=1200&auto=format&fit=crop"
          className="register-left-img"
          alt="ProCode Background"
        />

        <div className="register-left-overlay">
          <h1>Build With ProCode</h1>
          <p>Create your account and access the ProCode ecosystem.</p>
        </div>
      </div>

      {/* RIGHT FORM PANEL */}
      <div className="register-right">

        <div className="register-card">
          <img src={logo} alt="ProCode" className="register-logo" />

          <h2 className="register-title">Create Your Account</h2>
          <p className="register-subtitle">Start your journey with ProCode</p>

          {error && <p className="auth-message error">{error}</p>}
          {success && <p className="auth-message success">{success}</p>}

          <form onSubmit={handleSubmit} className="register-form">

            <div className="auth-field">
              <label className="auth-label">Email Address</label>
              <input
                type="email"
                className="auth-input"
                placeholder="you@example.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>

            <div className="auth-field">
              <label className="auth-label">Password</label>
              <input
                type="password"
                className="auth-input"
                placeholder="At least 6 characters"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>

            <div className="auth-field">
              <label className="auth-label">Confirm Password</label>
              <input
                type="password"
                className="auth-input"
                placeholder="Re-enter your password"
                value={confirm}
                onChange={(e) => setConfirm(e.target.value)}
                required
              />
            </div>

            <button type="submit" className="auth-button">
              Create Account
            </button>
          </form>

          <p className="auth-switch">
            Already have an account? <Link to="/login">Sign in</Link>
          </p>
        </div>

      </div>
    </div>
  );
}

export default Register;
